import Raven from 'raven-js';
import { useMemo, createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultValue = {
  isInCrmLocation: false,
  scopes: new Set(),
  gates: new Set()
};
const AuthContext = /*#__PURE__*/createContext(defaultValue);
export function useAuthContext() {
  const auth = useContext(AuthContext);
  if (!auth.isInCrmLocation) {
    // Log an exception to raven is auth is accessed not inside a location
    Raven.captureException(new Error('CRM SDK AuthContext has been accessed outside a card location'));
  }
  return auth;
}
export function AuthProvider({
  children,
  gates,
  scopes,
  isInCrmLocation = false
}) {
  const value = useMemo(() => {
    return {
      isInCrmLocation,
      gates: new Set(gates),
      scopes: new Set(scopes)
    };
  }, [isInCrmLocation, gates, scopes]);
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: value,
    children: children
  });
}